import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import {Size} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./IntroductionSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const IntroductionSection = (props: Props) => {
	return (
		<section>
			<Separator id={"introduction"} withoutMeasure>
				<ContainerWrapper>
					{props.data.mainContent?.[0] && (
						<div className={`${styles.container}`}>
							<ContentAssetSwitcher
								contentAssetProps={{
									contentProps: {
										titleProps: {
											style: {
												marginBottom: "2rem;",
											},
										},
										contentProps: {
											size: Size.XS,
										},
									},
									withAspectRation: false,
								}}
								data={props.data}
							/>
						</div>
					)}
				</ContainerWrapper>
			</Separator>
			<Separator size={128} />
			{/* <Separator id={"introduction"} withoutMeasure>
				<ContainerWrapper>
					{props.data.mainContent?.[0] && (
						<ContentAssetSwitcher
							contentAssetProps={{
								contentProps: {
									titleProps: {
										style: {
											marginBottom: "2rem;",
										},
									},
									contentProps: {
										size: Size.XS,
									},
								},
								withAspectRation: true,
							}}
							data={props.data}
						/>
					)}
				</ContainerWrapper>
			</Separator>
			<Separator size={128} /> */}
		</section>
	)
}

export default IntroductionSection
